import publicConfig from '@milo/config/config-public.json';
export default publicConfig;
